import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7520e0f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AlertsAndWarnings" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-title" }, "Detailed Description:", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "top-content" }
const _hoisted_6 = { class: "top-grid" }
const _hoisted_7 = { class: "flex-col-centered" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Status Visibility:", -1))
const _hoisted_9 = { class: "flex-row-centered" }
const _hoisted_10 = { title: "Number of assigned issues" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { title: "Number of unassigned issues" }
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-between","align-items":"center","column-gap":"0.3rem","min-width":"100%"}
}
const _hoisted_15 = { style: {"word-break":"break-all"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "failure"
}
const _hoisted_19 = {
  key: 1,
  class: "medium"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 0,
  class: "failure"
}
const _hoisted_22 = {
  key: 1,
  class: "medium"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "anw-info-textbox" }

import { ref, onMounted, inject } from "vue";
// Services
import log from "loglevel";
import { apiLoggerKey } from "@/types/ServiceKeys";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import { mantisIssues } from "@/services/network";
// Table
import Table from "@/components/TablePersistentChecking.vue";
// Misc
import { MantisIssue } from "@/models/MantisIssue";
import MarketSelector from "@/components/MarketSelector.vue";

const manageAnWHoverText = "Manage Alerts and Warnings in MantisHub (3rd party resource opens in new tab)";
const accessDeniedManageAnWHoverText = "Manage Alerts and Warnings in MantisHub (Access denied)";
const sortCol: keyof MantisIssue = "GetCreatedAt";

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsAndWarnings',
  setup(__props) {

const mantisUrl = process.env.VUE_APP_MANTIS_URL;

const cols: (keyof MantisIssue)[] = [
    "id",
    "summary",
    "description",
    "GetCategory", // "category",
    "GetSeverity", // "severity",
    "GetPriority", // "priority",
    "GetStatus", // "status",
    "GetModule", // "module",
    "GetCorrelationId", // "correlation_id",
    "GetVolvoTicketID",
    "GetAssignedTo", // "handler",
    "GetCreatedAt", // "created_at",
];
const labels = [
    "ID",
    "Issue Summary",
    "Detailed Description",
    "Category",
    "Severity",
    "Priority",
    "Status",
    "Module",
    "Correlation Id",
    "Volvo Ticket ID",
    "Assigned To",
    "Created At",
];

const page = ref(1);
const rowCount = ref(40);
const defaultSortCols = [cols.findIndex(col=>col === sortCol)];
const defaultSortOrders: (-1)[] = [-1];

log.debug("Alerts and Warnings");
const Logger = inject(apiLoggerKey);

////////////////////////////////////////////////////////////////////////////
// LOGIC
////////////////////////////////////////////////////////////////////////////
onMounted(async () => {
    log.trace("onMounted() AlertsAndWarnings");

    document.title = 'Alerts and Warnings - UV';

    await GetMantisIssues();
});
async function GetMantisIssues() {
    const name = __filename + "/" + GetMantisIssues.name;
    try {
        const data = (await mantisIssues.get()).data;
        alertsAndWarnings.value = data.issues.map(x=>new MantisIssue(x));
        displayedAlertsAndWarnings.value = data.issues;

        filterAlertsAndWarnings();
        sortAlertsAndWarnings();

        Logger?.LogInformation('Obtained Alerts and Warnings from API', name);
    } catch (error) {
        infoError.value = error;
        useNotifierWithErrFormatter().error({
            name,
            errorType: 'Getting Alerts and Warnings',
            error
        })
    }
}

// ERRORS
const infoError = ref();

// TABLE
const alertsAndWarnings = ref<MantisIssue[]>();
const displayedAlertsAndWarnings = ref<MantisIssue[]>();

// MISC
const showClosedTickets = ref(false);
const showAssignedTickets = ref(true);
const showUnassignedTickets = ref(true);

async function updateSelection() {
    log.trace("updateSelection()");
    // Fetch Data
    await GetMantisIssues();
}
function filterAlertsAndWarnings() {
    log.trace(`filterAlertsAndWarnings()\nshowClosedTickets: ${showClosedTickets.value}`);
    log.debug(`filterAlertsAndWarnings()\nshowClosedTickets: ${showClosedTickets.value}`);

    if (!showClosedTickets.value) {
        log.debug(`filterAlertsAndWarnings()\nRemove closed tickets`);
    }
    if (!showAssignedTickets.value) {
        log.debug(`filterAlertsAndWarnings()\nRemove assigned tickets`);
    }
    if (!showUnassignedTickets.value) {
        log.debug(`filterAlertsAndWarnings()\nRemove unassigned tickets`);
    }

    const filteredClosedTickets = showClosedTickets.value
        ? alertsAndWarnings.value
        : alertsAndWarnings.value?.filter(
            (issue: MantisIssue) =>
                !issue.status.name.toLowerCase().startsWith("closed")
        );

    const filteredAssignedTickets = showAssignedTickets.value
        ? filteredClosedTickets
        : filteredClosedTickets?.filter(
            (issue: MantisIssue) =>
                !issue.handler?.real_name?.length
        );

    const filteredUnassignedTickets = showUnassignedTickets.value
        ? filteredAssignedTickets
        : filteredAssignedTickets?.filter((issue: MantisIssue) =>
            Boolean(issue.handler?.real_name)
        );

    displayedAlertsAndWarnings.value = filteredUnassignedTickets;
    sortAlertsAndWarnings();
}
function sortAlertsAndWarnings() {
    log.trace("sortAlertsAndWarnings()");

    displayedAlertsAndWarnings.value = displayedAlertsAndWarnings.value?.sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );
}
function ManageAlertsAndWarnings() {
    log.trace("ManageAlertsAndWarnings()");
    // Open url in new tab
    window.open(mantisUrl, "_blank");
}
const showPopup = ref(false);
const detailedDescription = ref<string>();
function ViewDetailedDescription(description?: string) {
    log.debug("ViewDetailedDescription()\nDescription:", description);
    const regex = /\\n|\\r\\n|\\n\\r|\\r/g;
    detailedDescription.value = description
        ?.replaceAll("\\\\", "\\")
        .replace(regex, "<br>");
    showPopup.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (showPopup.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showPopup.value = false)),
            title: "Click to close detailed description.",
            class: "overlay"
          }, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              class: "popup"
            }, [
              _hoisted_3,
              _createElementVNode("div", {
                class: "wrap",
                innerHTML: detailedDescription.value
              }, null, 8, _hoisted_4),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showPopup.value = false)),
                  title: "Close detailed description. (You can also click outside the popup box to close detailed description.)"
                }, "Close")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(MarketSelector, { onChange: updateSelection }),
          _createElementVNode("button", {
            class: "centre-button",
            onClick: ManageAlertsAndWarnings,
            title: manageAnWHoverText
          }, " Manage Alerts & Warnings "),
          _createElementVNode("span", null, "Displayed Alerts and Warnings: " + _toDisplayString(alertsAndWarnings.value?.length), 1),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, " Assigned (" + _toDisplayString(alertsAndWarnings.value?.filter((issue) => {
                                        return (
                                            issue.handler?.real_name?.length
                                            && !issue.status.name.toLowerCase().startsWith('closed')
                                        );
                                    }).length) + ") ", 1),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                style: {"margin":"0"},
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showAssignedTickets).value = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (filterAlertsAndWarnings())),
                title: `Toggle visibility for assigned issues to ${!showAssignedTickets.value ? 'show' : 'hide'}`
              }, null, 40, _hoisted_11), [
                [_vModelCheckbox, showAssignedTickets.value]
              ]),
              _createTextVNode(", "),
              _createElementVNode("span", _hoisted_12, [
                _createTextVNode(" Unassigned ("),
                _createElementVNode("span", {
                  class: _normalizeClass(alertsAndWarnings.value?.filter((issue) => {
                                    return (
                                        !issue.handler?.real_name?.length
                                        && !issue.status.name.toLowerCase().startsWith('closed')
                                    );
                                }).length! > 0 ? 'failure' : '')
                }, _toDisplayString(alertsAndWarnings.value?.filter((issue) => {
                                        return (
                                            !issue.handler?.real_name?.length &&
                                            !issue.status.name
                                                .toLowerCase()
                                                .startsWith("closed")
                                        );
                                    }).length), 3),
                _createTextVNode(") ")
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                style: {"margin":"0"},
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showUnassignedTickets).value = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (filterAlertsAndWarnings())),
                title: `Toggle visibility for unassigned issues to ${!showUnassignedTickets.value ? 'show' : 'hide'}`
              }, null, 40, _hoisted_13), [
                [_vModelCheckbox, showUnassignedTickets.value]
              ])
            ])
          ])
        ])
      ]),
      _createVNode(Table, {
        Rows: displayedAlertsAndWarnings.value,
        Cols: cols,
        Labels: labels,
        HasError: !!infoError.value,
        RowsPerPage: rowCount.value,
        "onUpdate:RowsPerPage": _cache[7] || (_cache[7] = ($event: any) => ((rowCount).value = $event)),
        Page: page.value,
        "onUpdate:Page": _cache[8] || (_cache[8] = ($event: any) => ((page).value = $event)),
        DefaultSortCols: defaultSortCols,
        DefaultSortOrders: defaultSortOrders
      }, {
        description: _withCtx((props) => [
          (props.value.description.length > 30)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(props.value.description.slice(0, 30)) + "...", 1),
                _createElementVNode("button", {
                  class: "table-button",
                  onClick: ($event: any) => (ViewDetailedDescription(props.value.description)),
                  title: "View full description"
                }, " show ", 8, _hoisted_16)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(props.value.description), 1))
        ]),
        GetSeverity: _withCtx((props) => [
          (props.value.severity.name === 'crash')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(props.value.severity.name), 1))
            : (props.value.severity.name === 'major')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(props.value.severity.name), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(props.value.severity.name), 1))
        ]),
        GetPriority: _withCtx((props) => [
          (props.value.priority.name === 'high')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(props.value.priority.name), 1))
            : (props.value.priority.name === 'normal')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(props.value.priority.name), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(props.value.priority.name), 1))
        ]),
        _: 1
      }, 8, ["Rows", "HasError", "RowsPerPage", "Page"]),
      _createElementVNode("div", _hoisted_24, [
        _createTextVNode(" Please note, not all alerts and warnings are displayed in this portal. To view all alerts and warnings, please visit MantisHub  "),
        _createElementVNode("span", {
          title: manageAnWHoverText,
          onClick: _cache[9] || (_cache[9] = ($event: any) => (ManageAlertsAndWarnings())),
          class: _normalizeClass('text-link')
        }, "here"),
        _createTextVNode(". ")
      ])
    ])
  ]))
}
}

})